import Box from '@zenbusiness/zui/Box';
import { styled } from '@zenbusiness/zui/styles';

const DashboardWrapperStyle = ({ isDisplay }) => ({
  display: isDisplay ? 'block' : 'none',
  margin: 'auto',
  position: 'relative'
});

const LeftSideStyle = ({ theme }) => ({
  gridColumn: '1 / 5',
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    gridColumn: '1 / 7'
  },
  [theme.breakpoints.up('md')]: {
    gridColumn: '1 / 13'
  },
  [theme.breakpoints.up('lg')]: {
    gridColumn: '1 / 8'
  }
});

const RightSideStyle = ({ theme }) => ({
  gridColumn: '1 / 5',
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    gridColumn: '1 / 7'
  },
  [theme.breakpoints.up('md')]: {
    gridColumn: '1 / 13'
  },

  [theme.breakpoints.up('lg')]: {
    gridColumn: '8 / 13',
    paddingLeft: '36px'
  }
});

export const DashboardWrapperStyled = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isDisplay'
})(DashboardWrapperStyle);

export const LeftSideStyled = styled(Box)(LeftSideStyle);
export const RightSideStyled = styled(Box)(RightSideStyle);
